import React from "react"

export function OptionButton({ children, onClick, active }) {
  const classNames = active ? `bg-gray-100` : `bg-white`

  return (
    <button
      className={`p-2 flex-grow rounded hover:bg-gray-50 font-semibold focus:outline-none focus:bg-gray-100 transition-colors duration-200 ${classNames}`}
      onClick={onClick}
    >
      {children}
    </button>
  )
}
